<template>
  <b-card>
    <b-row>
    <location-card :location='this.location'></location-card>
  </b-row>
  <b-card header="Lock Groups">

    <b-row>
      <b-col cols="12" md="6" v-if="this.allowByHausType()">
        <lock-group-form></lock-group-form>
      </b-col>
      <b-col cols="12" md="6" v-if="this.allowByHausType()">
        <lock-group></lock-group>
      </b-col>
    </b-row>
  </b-card>
</b-card>
</template>

<script>
import LockGroup from '@/views/base/LockGroup'
import LockGroupForm from '@/views/base/LockGroupForm'
import LocationCard from '@/views/base/haus/LocationCard'

let qs = require('qs')
const constants = require('@/views/base/shared/constants')


export default {
  name: 'Lock-Group-Form-And-List',
  components: {
    LockGroup,
    LockGroupForm,
    LocationCard
  },
  data: () => {
    return {
      user: {},
      location: {}
    }
  },
  mounted () {

    this.getLocalLocationDetail()
  },
  methods: {
    openlink (link) {
      location.href = link
    },
    getLocalLocationDetail() {
      let localLocationsList = localStorage.getItem('localLocationsList')
      let localLocationId = localStorage.getItem('locationId')
      if (localLocationsList == null || localLocationsList == 'undefined') {
        constants.gotoLogin()
      } else {
        localLocationsList = JSON.parse(localLocationsList)
        for (let i in localLocationsList) {
          let loopLocation = localLocationsList[i]
          if (localLocationId == loopLocation.id) {
            this.$data.location = loopLocation
            if (loopLocation.owner.name === null) {
              this.$data.location.owner.name = localStorage.getItem('name')
            }
            return loopLocation
          }
        }
        return null
      }
    },
    allowByHausType () {
      let haustype = localStorage.getItem('ouht')
      if (haustype == 1) {
        return true
      } else return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockGroupFormAndList.vue